import {
  CREATE_ASSET,
  DELETE_ASSET,
  LIST_ASSETS,
  setCreateAssetProcessing,
  setCreateAssetSuccess,
  setCreateAssetError,
  setDeleteAssetProcessing,
  setDeleteAssetSuccess,
  setDeleteAssetError,
  setListAssetsError,
  setListAssetsProcessing,
  setListAssetsSuccess,
} from './actions'
import {
  createAsset, deleteAsset, listAssets,
} from '..'

const log = console

async function createAssetHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  try {
    store.dispatch(setCreateAssetProcessing(payload))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      body: payload,
    }

    const asset = await createAsset(options)
    store.dispatch(setCreateAssetSuccess(asset))
  } catch (error) {
    log.error(error, 'Error creating asset.')
    store.dispatch(setCreateAssetError({
      ...payload,
      error,
    }))
  }
}

async function deleteAssetHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  try {
    store.dispatch(setDeleteAssetProcessing(payload))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      body: payload,
    }
    const asset = await deleteAsset(options)
    store.dispatch(setDeleteAssetSuccess(asset))
  } catch (error) {
    log.error(error, 'Error deleting asset.')
    store.dispatch(setDeleteAssetError({
      ...payload,
      error,
    }))
  }
}

async function listAssetsHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  try {
    store.dispatch(setListAssetsProcessing(payload))
    const asset = await listAssets({
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      query: payload,
    })
    store.dispatch(setListAssetsSuccess(asset))
  } catch (error) {
    log.error(error, 'Error listing asset.')
    store.dispatch(setListAssetsError({
      ...payload,
      error,
    }))
  }
}

export default (store) => (next) => (action) => {
  const { type, payload } = action
  switch (type) {
    case CREATE_ASSET:
      createAssetHandler({ store, payload })
      break
    case DELETE_ASSET:
      deleteAssetHandler({ store, payload })
      break
    case LIST_ASSETS:
      listAssetsHandler({ store, payload })
      break
    default:
      break
  }
  next(action)
}
